'use client';

import { JSX, useState } from 'react';

import { useIdle } from 'hooks/useIdle';

interface IdleProps {
	children: React.ReactNode;
	onIdle?: () => void;
	fallback?: () => JSX.Element | React.ReactNode;
}

function Idle(props: IdleProps) {
	// States
	const [isIdle, setIsIdle] = useState(false);

	// Custom hooks
	useIdle(() => {
		setIsIdle(true);
		props.onIdle?.();
	});

	return isIdle ? (
		<>{props.children}</>
	) : props.fallback ? (
		<props.fallback />
	) : null;
}

export default Idle;
